import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class PromotionService {

  constructor(private http: HttpClient) { }

  get_promotionList_top3() {
    let _latestNewsUrl = cmsApi + '/get_promotionList_top3/'
    let _latestNewsBody = {}
    return this.http.post(_latestNewsUrl, _latestNewsBody)
  }

  get_benefitList_top3() {
    let _latestNewsUrl = cmsApi + '/get_benefitList_top3/'
    let _latestNewsBody = {}
    return this.http.post(_latestNewsUrl, _latestNewsBody)
  }

  get_promotionList() {
    let _getNewsPeriodUrl = cmsApi + '/get_promotionList/'
    let _getNewsPeriodBody = { IsActive: '1', search: '' }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_promotionList_active() {
    let _getNewsPeriodUrl = cmsApi + '/get_promotionList_active/'
    let _getNewsPeriodBody = { IsActive: '1', search: '' }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_benefitList() {
    let _getNewsPeriodUrl = cmsApi + '/get_benefitList/'
    let _getNewsPeriodBody = { IsActive: '1', search: '' }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_benefitList_active() {
    let _getNewsPeriodUrl = cmsApi + '/get_benefitList_active/'
    let _getNewsPeriodBody = { IsActive: '1', search: '' }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  changeFormatDate(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return day + ' ' + monthTh['name'] + ' ' + year;
    }
  }

  date_thai(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day   = d.getDate();
    const year  = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (day + ' ' + monthTh['name'] + ' ' + year);
  }

  checkMonth: Array<Object> = [
    {
      number: 1,
      name: 'มกราคม'
    },
    {
      number: 2,
      name: 'กุมภาพันธ์'
    },
    {
      number: 3,
      name: 'มีนาคม'
    },
    {
      number: 4,
      name: 'เมษายน'
    },
    {
      number: 5,
      name: 'พฤษภาคม'
    },
    {
      number: 6,
      name: 'มิถุนายน'
    },
    {
      number: 7,
      name: 'กรกฎาคม'
    },
    {
      number: 8,
      name: 'สิงหาคม'
    },
    {
      number: 9,
      name: 'กันยายน'
    },
    {
      number: 10,
      name: 'ตุลาคม'
    },
    {
      number: 11,
      name: 'พฤศจิกายน'
    },
    {
      number: 12,
      name: 'ธันวาคม'
    }
  ];


}
